/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'

export default class SuccesSend extends Component {

  constructor(props){
    super(props);
    this.state = {

    }
  }
  render() {
    return  <div className="container">
              <div className="go-form-step">
                <div className="go-step-header">
                  <div className="rs-card align-center" style={{marginTop: 20 }}>
                    <div className="card-bdy intermediate">
                      <p className="emoji-alert">😀</p>
                      <h1>Votre pré-inscription à été enregistré avec succes !</h1>
                    </div>
                    <div className="card-bdy compact">
                      <p>L'équipe Royal Speed vous recontactera dans dans un délai de 24h (hors week-ends & jours fériés).<br/> Vous pouvez également nous contacter au 01 45 55 27 17.</p>
                      <p>Merci de nous faire confiance.</p>
                      <a href="https://royalspeed.fr" className="button go-button">Retour à royalspeed.fr</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  }

}


// WEBPACK FOOTER //
// ./go/views/components/signup/succesSend.jsx